import type { Namespace } from '../types';

// DE partially sourced from the spec HTML's `access` view (`tr(de,en)` pairs:
// "Zugriff & Rollen", "kein Zugriff", "Freigabe"); the rest drafted — queued for
// native review in the task file's "DE review queue".
export const accessRoles = {
  title: { de: 'Zugriff & Rollen', en: 'Access & Roles' },
  desc: {
    de: 'Rollen × Module Berechtigungsmatrix. „Berechtigungen bearbeiten" öffnet die Bearbeitung — Änderungen erreichen die Standort-Durchsetzung innerhalb einer Minute.',
    en: 'Role × module permission matrix. Press Edit Permissions to change levels — changes reach site enforcement within a minute.',
  },
  newRole: { de: 'Neue Rolle', en: 'New Role' },

  loadError: {
    de: 'Berechtigungsmatrix konnte nicht geladen werden.',
    en: "Couldn't load the permission matrix.",
  },
  emptyTitle: { de: 'Noch keine Rollen', en: 'No roles yet' },
  emptyMsg: {
    de: 'Erstellen Sie die erste Rolle, um Zugriff zu gewähren.',
    en: 'Create the first role to start granting access.',
  },

  legendNone: { de: 'kein Zugriff', en: 'no access' },
  legendRead: { de: 'Lesen', en: 'read' },
  legendWrite: { de: 'Schreiben', en: 'write' },
  legendApprove: { de: 'Freigabe', en: 'approve' },
  legendAdmin: { de: 'Admin', en: 'admin' },
  legendNote: {
    de: 'Stufen sind geordnet — eine Stufe schließt alle darunter ein. Administratoren umgehen die Matrix.',
    en: 'Levels are ordered — holding a level implies everything below it. Administrators bypass the matrix.',
  },

  toastSaveFailed: { de: 'Speichern fehlgeschlagen: {error}', en: "Couldn't save: {error}" },
  unknownError: { de: 'unbekannter Fehler', en: 'unknown error' },
  toastRoleCreated: { de: 'Rolle „{name}“ erstellt', en: 'Role "{name}" created' },
  toastRoleFailed: { de: 'Rolle konnte nicht erstellt werden: {error}', en: "Couldn't create role: {error}" },

  roleId: { de: 'Rollen-ID', en: 'Role id' },
  slugHint: {
    de: 'Slug: Kleinbuchstaben, beginnt mit einem Buchstaben, a-z 0-9 _ -',
    en: 'Slug: lowercase, starts with a letter, a-z 0-9 _ -',
  },
  egRoleId: { de: 'z. B. shift_lead', en: 'e.g. shift_lead' },
  egRoleName: { de: 'z. B. Shift Lead', en: 'e.g. Shift Lead' },
  descOptional: { de: 'Beschreibung (optional)', en: 'Description (optional)' },
  descPlaceholder: { de: 'Wofür diese Rolle gedacht ist', en: 'What this role is for' },
  creating: { de: 'Wird erstellt…', en: 'Creating…' },
  createRole: { de: 'Rolle erstellen', en: 'Create role' },

  // View / edit mode (2026-09-28): the matrix is read-only until Edit; changes are
  // a local draft until Save, which writes each changed cell.
  editPermissions: { de: 'Berechtigungen bearbeiten', en: 'Edit Permissions' },
  editingBanner: {
    de: 'Bearbeitungsmodus — Zelle anklicken, um die Stufe zu wechseln. Nichts wird gespeichert, bevor Sie „Speichern" drücken.',
    en: 'Editing — click a cell to change its level. Nothing is saved until you press Save.',
  },
  changesCount: { de: '{n} ungespeicherte Änderung(en)', en: '{n} unsaved change(s)' },
  noChanges: { de: 'Keine Änderungen', en: 'No changes' },
  saveN: { de: 'Speichern ({n})', en: 'Save ({n})' },
  discardTitle: { de: '{n} Änderung(en) verwerfen?', en: 'Discard {n} change(s)?' },
  discardMsg: {
    de: 'Die geänderten Zellen gehen auf ihren gespeicherten Stand zurück.',
    en: 'The changed cells go back to what is saved.',
  },
  discard: { de: 'Verwerfen', en: 'Discard' },
  toastSavedAll: { de: '{n} Berechtigung(en) gespeichert', en: '{n} permission(s) saved' },
  toastPartial: {
    de: '{ok} von {n} gespeichert. Fehlgeschlagen: {failed} — diese Zellen bleiben im Entwurf.',
    en: 'Saved {ok} of {n}. Failed: {failed} — those cells stay in the draft.',
  },
  changed: { de: 'geändert', en: 'changed' },
} as const satisfies Namespace;
